module.exports = __webpack_public_path__ + "img/live-stream-lg.9b70b655.png";